import { render, staticRenderFns } from "./accountManagementAdd.vue?vue&type=template&id=6706aaec&scoped=true"
import script from "./accountManagementAdd.vue?vue&type=script&lang=js"
export * from "./accountManagementAdd.vue?vue&type=script&lang=js"
import style0 from "./accountManagementAdd.vue?vue&type=style&index=0&id=6706aaec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6706aaec",
  null
  
)

export default component.exports